export default "__VITE_ASSET__D3xBH8yz__"